module.exports = __webpack_public_path__ + "d5b38d67fa69134f63f30b21dfef3a93.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_medium-webfont.woff
// module id = 1wFz
// module chunks = 0